import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {UiChecklistGroupFieldsComponent} from './components/ui-checklist-group/ui-checklist-group-fields.component';
import {FormularioModel} from '../../../../../model/planilhas/formulario.model';
import {CampoFormularioModel} from '../../../../../model/planilhas/campo-formulario.model';
import {AssinaturaFormularioValor, PreenchFormModel} from '../../../../../model/planilhas/preench-form.model';
import {FormularioService} from '../../../../../service/planilhas/formulario.service';
import {Geo} from './components/ui-checklist-group/ui-checklist-group-fields.component';
import UiSwal from '../../../misc/ui-swal';
import {PreenchFechFormularioService} from '../../../../../service/refatorar/preench-fech-formulario.service';
import {UiModalComponent} from '../ui-modal/ui-modal.component';
import {lastValueFrom} from 'rxjs';
import {ToastrService} from 'ngx-toastr';
import {GenericValidator} from '../../../../validacoes-form';

type ChecklistContent = {
    preenchimentos: PreenchFormModel[];
    arquivos: File[];
    callback: () => void;
}

type _ChecklistUtils = {
    selected?: boolean,
}

@Component({
    selector: 'ui-checklist',
    templateUrl: './ui-checklist.component.html',
    styleUrls: ['./ui-checklist.component.scss'],
    standalone: false
})
export class UiChecklistComponent implements OnInit {
    listFiles: File[] = [];
    formulario: FormularioModel;
    preenchimentos: PreenchFormModel[] = [];
    preenchimentosVisivel: PreenchFormModel[] = [];
    preenchimentosCondicional: PreenchFormModel[] = [];
    selectedGrupo: CampoFormularioModel & _ChecklistUtils;
    selectedCampoIndex: number;
    filteredPreenchimento: PreenchFormModel;
    verificado = false;
    invalidItems: any[];
    arquivos: File[] = [];

    grupos: (CampoFormularioModel & _ChecklistUtils)[] = [];
    gruposCondicionais: (CampoFormularioModel & _ChecklistUtils)[] = [];

    @Input() loading = false;
    @Input() edit = false;
    @Input() uuidPreenchimento: string;
    @Input() idFormulario: number;
    @Input() title: string;
    @Output() salvarEmitter = new EventEmitter<ChecklistContent>();
    @ViewChild(UiChecklistGroupFieldsComponent) fields: UiChecklistGroupFieldsComponent;
    @ViewChild(UiModalComponent) modalCampos: UiModalComponent;

    constructor(
        private preenchFormService: PreenchFechFormularioService,
        private formularioService: FormularioService,
        private toastr: ToastrService
    ) {
        this.loading = true;
        this.verificado = false;
    }

    async ngOnInit() {
        await this.loadFormulario();

        if (this.uuidPreenchimento) {
            await this.loadPreenchimento();
            this.fillPreenchimentosWithGrupos();
        } else {
            this.fillPrimeiroPreenchimentoWithGrupo();
        }
        this.initWizard();
        this.loading = false;
    }

    private initWizard() {
        this.selectedGrupo = this.formulario.campos[0];
        this.selectedGrupo.selected = true;
        this.selectedCampoIndex = 0;
        this.filteredPreenchimento = this.preenchimentosVisivel[0];
    }

    async loadFormulario() {
        const throwErrorSwal = () => {
            UiSwal.fire({
                icon: 'warning',
                title: 'Ops... Algo deu errado!',
                text: 'Tivemos um problema ao carregar seu formulário. Tente novamente mais tarde. Caso o problema ' +
                    'persista, entre em contato com a Central de Atendimentos.',
                showConfirmButton: false,
                showCancelButton: true,
                cancelButtonText: 'Fechar',
            }).then(() => window.history.back())
        };

        try {
            let formularioId = this.idFormulario;

            if (this.uuidPreenchimento) {
                const resp = await lastValueFrom(this.preenchFormService.findAllPreenchimentoByConectaPreenchimentos(this.uuidPreenchimento));

                if (resp.status === 'SUCCESS') {
                    this.preenchimentos = resp.data;
                } else {
                    this.toastr.error("Erro ao carregar formulário");
                    throwErrorSwal();
                }

                const grupo = await lastValueFrom(this.formularioService.getCampoFormulario(this.preenchimentos[0].campo_formulario_id));

                formularioId = grupo.data.formulario_id;
            }

            const response = await lastValueFrom(this.formularioService.getFormulario(formularioId));

            if (response?.status === 'SUCCESS') {
                this.formulario = response.data;
            } else {
                this.toastr.error("Fase SVE não encontrada");
                throwErrorSwal();
            }

            this.grupos = this.formulario.campos.filter(campo =>
                campo.visibilidade === CampoFormularioModel.VISIBILIDADE_VISIVEL)
                .sort((a, b) => a.id - b.id);

            this.gruposCondicionais = this.formulario.campos.filter(campo =>
                campo.visibilidade === CampoFormularioModel.VISIBILIDADE_CONDICIONAL)
                .sort((a, b) => a.id - b.id);
        } catch (e) {
            throwErrorSwal();
        }
    }

    async loadPreenchimento() {
        this.preenchimentosVisivel = this.deepClone(this.preenchimentos
            .filter(pr => !pr.preenchimento_campo_id));
        this.preenchimentosVisivel.sort((a, b) => a.campo_formulario_id - b.campo_formulario_id);
        this.preenchimentosCondicional = this.deepClone(this.gruposCondicionaisComPreenchidos(this.preenchimentos
            .filter(pr => pr.preenchimento_campo_id)));
    }

    gruposCondicionaisComPreenchidos(gruposPreenchidos: PreenchFormModel[]): PreenchFormModel[] {
        const gruposCondicionais = this.formulario.campos
            .filter(c => c.visibilidade === CampoFormularioModel.VISIBILIDADE_CONDICIONAL);
        return gruposCondicionais.flatMap(grp => {
            const gatilhos = grp.gatilhos_condicionais;
            if (gatilhos && gatilhos.length > 0) {
                return gatilhos.map(gatilho => {
                    const grupoPreenchido = gruposPreenchidos
                        .find(g => g.gatilho_condicional?.id === gatilho.id);
                    if (grupoPreenchido) {
                        grupoPreenchido._campo = grp;
                        grupoPreenchido.campo_formulario_id = grp.id;
                        return grupoPreenchido;
                    }
                    const grupo = this.formulario.campos.find(g => g.id === gatilho.campo_formulario_id);
                    if (grupo) {
                        return new PreenchFormModel({
                            _campo: grupo,
                            campo_formulario_id: grupo.id,
                            gatilho_condicional: gatilho
                        });
                    }
                });
            } else {
                return [];
            }
        });
    }

    fillPreenchimentosWithGrupos() {
        this.preenchimentosVisivel.forEach(pv => {
            pv._campo = this.formulario.campos.find(cp => cp.id === pv.campo_formulario_id);
        });
        this.processDates(this.preenchimentosVisivel);
        this.preenchimentosCondicional.forEach(pv => {
            pv._campo = this.formulario.campos.find(cp => cp.id === pv.campo_formulario_id);
        });
        this.processDates(this.preenchimentosCondicional);
    }

    fillPrimeiroPreenchimentoWithGrupo() {
        this.formulario.campos?.forEach(grp => {
            if (grp.visibilidade === CampoFormularioModel.VISIBILIDADE_VISIVEL) {
                const model = new PreenchFormModel({
                    _campo: grp,
                    campo_formulario_id: grp.id,
                });
                this.preenchimentosVisivel.push(model);
            }
        });
        this.preenchimentosCondicional = this.getConditionalGroupsModels();
    }

    getConditionalGroupsModels(): PreenchFormModel[] {
        const gruposCondicionais = this.formulario.campos
            ?.filter(c => c.visibilidade === CampoFormularioModel.VISIBILIDADE_CONDICIONAL);
        return gruposCondicionais?.flatMap(grp => {
            const gatilhos = grp.gatilhos_condicionais;
            if (gatilhos && gatilhos.length > 0) {
                return gatilhos.map(gatilho => {
                    const grupo = this.formulario.campos.find(g => g.id === gatilho.campo_formulario_id);
                    if (grupo) {
                        return new PreenchFormModel({
                            _campo: grupo,
                            campo_formulario_id: grupo.id,
                            gatilho_condicional: gatilho
                        });
                    }
                });
            } else {
                return [];
            }
        });
    }

    goToNext() {
        const campoIndex = this.selectedCampoIndex;
        const lastCampoIndex = this.grupos.length - 1;

        if (campoIndex !== lastCampoIndex) {
            this.selectGroup(this.grupos[campoIndex + 1], campoIndex + 1);
            return;
        }
    }
    goToPrevious() {
        const campoIndex = this.selectedCampoIndex;

        if (campoIndex !== 0) {
            this.selectGroup(this.grupos[campoIndex - 1], campoIndex - 1);
            return;
        }
    }

    updateFotos(event) {
        if (event && event.length > 0) {
            event.forEach(file => {
                if (!this.verificaSeArquivoExisteNaLista(file)) {
                    this.listFiles.push(file);
                }
            });
        } else {
            if (!this.verificaSeArquivoExisteNaLista(event)) {
                this.listFiles.push(event);
            }
        }
    }

    verificaSeArquivoExisteNaLista(file: any): boolean {
        let encontrou = false;
        this.listFiles.forEach(item => {
            if (file === item) {
                encontrou = true;
            }
        });
        return encontrou;
    }

    selectGroup(grupo: CampoFormularioModel & _ChecklistUtils, campoIndex: number) {
        if (grupo === this.selectedGrupo) {
            return;
        }

        grupo.selected = true;
        this.selectedGrupo.selected = false;

        this.selectedGrupo = grupo;
        this.selectedCampoIndex = campoIndex;

        this.fields.animateUnderlineMethod();
        this.filteredPreenchimento = this.preenchimentosVisivel[campoIndex];
    }

    handleSaveButtonDisabled() {
        return this.edit || this.verificado ? false : this.selectedCampoIndex < this.grupos.length - 1;
    }

    async handleSave() {
        if (this.verificaForm() && this.verificaFormCond()) {
            this.loading = true;
            const rs = await UiSwal.fire({
                title: 'Salvar checklist',
                text: 'Deseja salvar o checklist?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Salvar',
                cancelButtonText: 'Voltar',
            });
            if (rs.isConfirmed) {
                this.save();
            } else {
                this.loading = false;
            }
        } else {
            this.modalCampos.openModal();
        }
    }


    private assinaturaFormularioInvalida(valor: unknown, opcional: boolean): boolean {
        const assinatura =
            valor as Partial<AssinaturaFormularioValor> | null | undefined;

        const nome = assinatura?.nomeAssinante?.trim() ?? '';
        const cpf = assinatura?.cpfAssinante?.trim() ?? '';

        const imagem =
            assinatura?.imagemBase64?.trim() ||
            assinatura?.caminhoImagem?.trim() ||
            '';

        const assinaturaVazia = !nome && !cpf && !imagem;

        if (assinaturaVazia) {
            return !opcional;
        }

        return (
            !nome ||
            !imagem ||
            !GenericValidator.campoCPF(cpf)
        );
    }

    private verificaForm(): boolean {
        this.invalidItems = [];
        for (const p of this.preenchimentosVisivel) {
            for (const d of p.dados) {
                const estrutura = p._campo.estrutura.find(
                    item => item.id === d.id
                );

                if (estrutura?.tipo === 'assinaturaFormulario') {
                    const invalida = this.assinaturaFormularioInvalida(
                        d.valor,
                        estrutura.opcional === true
                    );

                    if (invalida) {
                        this.getCampoNomeSemPreenchimento(p, d.id);
                    }

                    continue;
                }

                if (d.valor instanceof Geo && (!d.valor.lat || !d.valor.lng || !d.valor.acc)) {
                    this.getCampoNomeSemPreenchimento(p, d.id);
                }

                if (d.valor === undefined || d.valor === null || d.valor === '') {
                    let isAssinatura = false;
                    let isOpcional = false;
                    p._campo.estrutura.forEach(estrutura => {
                        if (estrutura.tipo === 'assinatura' && d.id === estrutura.id) {
                            isAssinatura = true;
                        }
                        if (estrutura.opcional === true && d.id === estrutura.id) {
                            isOpcional = true;
                        }
                    });
                    if (!isAssinatura && !isOpcional) {
                        this.getCampoNomeSemPreenchimento(p, d.id);
                    }
                }

                if (d.outro_valor === '' || d.outro_valor === null || d.outro_valor === undefined) {
                    let isCond = false;
                    p._campo.estrutura.forEach(estrutura => {
                        if (estrutura.cond_item && d.id === estrutura.id) {
                            if (estrutura.tipo === 'listaFixa') {
                                isCond = d.valor === estrutura.cond_item;
                            } else if (estrutura.tipo === 'listaMultipla') {
                                const valores: string[] = [d.valor];
                                isCond = !!valores?.find(valor => valor === estrutura.cond_item);
                            }
                        }
                    });

                    if (isCond) {
                        this.getCampoNomeSemPreenchimento(p, d.id);
                    }
                }
            }
        }
        this.verificado = true;
        return this.invalidItems.length <= 0;
    }

    private verificaFormCond() {
        this.invalidItems = [];
        for (const p of this.preenchimentosCondicional) {
            for (const d of p.dados) {
                if ((d.valor === undefined || d.valor === null || d.valor === '') && p.preenchimento_campo_id) {
                    let isAssinatura = false;
                    let isOpcional = false;
                    p._campo.estrutura.forEach(estrutura => {
                        if (estrutura.tipo === 'assinatura' && d.id === estrutura.id) {
                            isAssinatura = true;
                        }
                        if (estrutura.opcional === true && d.id === estrutura.id) {
                            isOpcional = true;
                        }
                    });
                    if (!isAssinatura && !isOpcional) {
                        this.getCampoNomeSemPreenchimento(p, d.id);
                    }
                }
                if (d.outro_valor === '' || d.outro_valor === null || d.outro_valor === undefined) {
                    let isCond = false;
                    p._campo.estrutura.forEach(estrutura => {
                        if (estrutura.cond_item && d.id === estrutura.id) {
                            if (estrutura.tipo === 'listaFixa') {
                                isCond = d.valor === estrutura.cond_item;
                            } else if (estrutura.tipo === 'listaMultipla') {
                                const valores: string[] = [d.valor];
                                isCond = !!valores?.find(valor => valor === estrutura.cond_item);
                            }
                        }
                    });
                    if (isCond) {
                        this.getCampoNomeSemPreenchimento(p, d.id);
                    }
                }
            }
        }

        return this.invalidItems.length <= 0;
    }

    private getCampoNomeSemPreenchimento(grupoPreenchimento: PreenchFormModel, id: number) {
        const estruturaFiltrada = grupoPreenchimento._campo.estrutura.find(estr => estr.id === id);
        if (estruturaFiltrada) {
            let existingEntry;
            let titulo;
            if (grupoPreenchimento._campo.visibilidade === CampoFormularioModel.VISIBILIDADE_CONDICIONAL) {
                titulo = this.grupos
                    .find(grp => grp.id === grupoPreenchimento.gatilho_condicional.gatilho_campo_formulario_id)
                    .titulo + '->' + grupoPreenchimento._campo.titulo;
                existingEntry = this.invalidItems.find(item => item.titulo === titulo);
            } else {
                titulo = grupoPreenchimento._campo.titulo;
                existingEntry = this.invalidItems.find(item => item.titulo === titulo);
            }

            if (existingEntry) {
                existingEntry.nome.push(estruturaFiltrada.nome);
            } else {
                const newItem: { titulo: string, nome: any[] } = {titulo: titulo, nome: [estruturaFiltrada.nome]};
                this.invalidItems.push(newItem);
            }
        }
    }

    getCurrentLocation(): Promise<Geo> {
        return new Promise<Geo>((resolve, reject) => {
            const options: PositionOptions = {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 0
            };

            navigator.geolocation.getCurrentPosition(
                (position) => {
                    resolve({
                        lat: position.coords.latitude.toString(),
                        lng: position.coords.longitude.toString(),
                        acc: position.coords.accuracy.toString()
                    });
                },
                (error) => {
                    reject(error);
                },
                options
            );
        });
    }

    private async save() {
        this.loading = true;
        try {
            const currentLocation = await this.getCurrentLocation();
            const preenchimentosSalvar = this.deepClone(this.preenchimentosVisivel);
            preenchimentosSalvar.push(...this.preenchimentosCondicional
                .filter(grp => grp.preenchimento_campo_id));

            preenchimentosSalvar.forEach(p => {
                p.fase_id = this.formulario.fase[0].id;
                p.gps = currentLocation;
            });
            this.processDates(preenchimentosSalvar);

            this.salvarEmitter.emit({
                preenchimentos: preenchimentosSalvar,
                arquivos: this.arquivos,
                callback: () => this.loading = false
            });
        } catch (error) {
            this.loading = false;
            let title = 'Erro ao Obter Localização';
            let text = 'Ocorreu um problema inesperado. Tente novamente mais tarde.';

            if (error instanceof GeolocationPositionError) {
                switch (error.code) {
                    case GeolocationPositionError.PERMISSION_DENIED:
                        title = 'Permissão de Localização Negada';
                        text = 'Para continuar, você precisa habilitar o acesso à sua localização nas configurações do navegador.';
                        break;
                    case GeolocationPositionError.POSITION_UNAVAILABLE:
                        title = 'Localização Indisponível';
                        text = 'Não foi possível determinar sua posição. Verifique se o serviço de localização (GPS) do seu dispositivo está ativado e se há um bom sinal.';
                        break;
                    case GeolocationPositionError.TIMEOUT:
                        title = 'Tempo Esgotado';
                        text = 'A solicitação de localização expirou. Verifique sua conexão com a internet e tente novamente.';
                        break;
                }
            }

            UiSwal.fire({
                icon: 'warning',
                title: title,
                text: text,
                showConfirmButton: true,
                confirmButtonText: 'Ok',
            });
        }
    }

    private deepClone<T>(obj: T): T {
        return JSON.parse(JSON.stringify(obj));
    }

    private processDates(preenchimentos: PreenchFormModel[]): void {
        preenchimentos.forEach(grp => grp._campo.estrutura.forEach(campo => {
            if (campo.tipo === 'dataHora') {
                grp.dados.forEach(dado => {
                    if (dado.id === campo.id && dado.valor) {
                        if (!dado.valor.toString().includes('T')) {
                            dado.valor = dado.valor.toString().concat('T00:00');
                        }
                    }
                });
            }
        }));
    }
}
